// @flow
import uuid from 'uuid';

import * as actions from './temporaryEvents';


export const shout = (
  message: string,
  lifespan?: number = 2000,
  accented?: Array<number> | number,
  data: Object,
) => actions.add(
  uuid(),
  lifespan,
  { message, accented, ...data },
  'flashMessages',
  true,
);



// WEBPACK FOOTER //
// ./src/scripts/actions/flashMessages.js